import { YinzCamAPIRequestComponent, YinzCamAPIResponse } from 'yinzcam-api';
import { AbstractReactiveMicrocomponent } from 'yinzcam-rma';
import { YinzCamCardsServiceStyle } from './YinzCamCardsServiceTypes';

export class YinzCamCardsServiceStyleComponent extends AbstractReactiveMicrocomponent<YinzCamCardsServiceStyle, [YinzCamAPIResponse]> {
  public constructor(name: string, srvInput: YinzCamAPIRequestComponent) {
    super({ name }, srvInput);
  }

  protected async update($control: unknown, $srvrsp: YinzCamAPIResponse): Promise<YinzCamCardsServiceStyle> {
    if (!$srvrsp?.data) {
      throw Error('YinzCamCardsServiceStyleComponent: style data not available');
    }
    return $srvrsp.data as YinzCamCardsServiceStyle;
  }
}
